<template>
  <div>
    <v-card class="border-radius-10">
      <v-card-title class="main-gradient">
        <span class="font-weight-black title title-form">Atenção!</span>
      </v-card-title>
      <v-card-text v-if="show_empty_fields_message()">
        <span class="font-weight-black title title-form">Campo(s) obrigatório(s) não preenchido(s)</span>
        <h3  v-for="empty_field in required_empty_fields">{{ empty_field }}</h3>
      </v-card-text>
      <v-card-text v-else>
        <span class="font-weight-black title title-form">{{getErrorMessage()}}</span>
      </v-card-text>
      <v-card-actions>
        <v-layout class="row wrap">
          <v-flex class="s12 justify-flex-end">
            <v-btn class="font-weight-black flex-1 btn-bg-color text-color-white" @click="closeDialog">OK</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'AdminPartnerCreateErrorMessage',
  props: {
    required_empty_fields: {
      type: Array
    },
    errors:{
      type: Object
    }
  },
  data(vm) {
    return {
      step: 1
    }
  },
  methods: {
    show_empty_fields_message() {
      return this.required_empty_fields.length > 0
    },
    getErrorMessage() {
      if(this.errors.step && this.errors.step=='user_creation_error') {
        this.step = 1
        return this.getUserCreationError()
      } else if(this.errors.step=='company_creation_error') {
        this.step = 1
        return this.getCompanyCreationError()
      } else if(this.errors.step && this.errors.step=='company_taxes_error') {
        this.step = 2
        return this.getCompanyTaxesCreationError()
      }  else if(this.errors.step && this.errors.step=='facilita_bank_account_creation_error') {
        this.step = 3
        return this.getFacilitaBankAccountCreationError()
      }  else if(this.errors.step &&  this.errors.step=='set_auto_scheduled_bank_account_error') {
        this.step = 3
        return this.getAutoScheduledBankAccountError()
      } else if(this.errors.step && this.errors.step=='partner_bank_account_creation_error') {
        this.step = 4
        return this.getPartnerBankAccountCreationError()
      }
    },
    getUserCreationError() {
      if (this.errors.error && this.errors.error.hasOwnProperty('username')) {
        switch (this.errors.error.username[0]) {
          case 'has invalid format':
            return "Username com formato inválido"
          case 'already exists':
            return "Username já cadastrado"
          default:
            return "Erro no processo de criação do usuário. Step: `user_creation_error`, campo: `username`";
        }
      } else {
        return "Erro na criação do usuário. Step: `user_creation_error`"; 
      }
    },
    getCompanyCreationError() {
      if (this.errors.error && this.errors.error.hasOwnProperty('document_number')) {
        switch (this.errors.error.document_number[0]) {
          case 'invalid':
            return "Número de documento da empresa com formato inválido"
          case 'Document number already registered':
            return "Número de documento da empresa já registrado"
          default:
            return "Erro no processo de criação do parceiro. Step: `partner_bank_account_creation_error`, campo: `Número do documento`";
        }
      } else {
        return "Erro não mapeado no processo de criação do parceiro. Step: `partner_bank_account_creation_error`"; 
      }
    },
    getPartnerBankAccountCreationError() {
      if (this.errors.error && this.errors.error.hasOwnProperty('bank')) {
        switch (this.errors.error.bank.code[0]) {
          case 'has invalid format. Three digits are expected like: 001':
            return "Código do banco inválido. Três dígitos são esperados, como: 001"
          default:
            return "Erro no processo de criação de conta do parceiro. Step: `company_creation_error`, por exemplo: `Código do banco`";
        }
      } else {
        return "Erro não mapeado no processo de criação de conta do parceiro. Step: `company_creation_error`"; 
      }
    },
    getFacilitaBankAccountCreationError() {
      if (this.errors.error && this.errors.error.hasOwnProperty('bank')) {
        switch (this.errors.error.bank.code[0]) {
          case 'has invalid format. Three digits are expected like: 001':
            return "Código do banco inválido. Três dígitos são esperados, por exemplo: 001"
          default:
            return "Erro no processo de criação da conta da facilita. Step: `facilita_bank_account_creation_error`, campo: `Código do banco`";
        }
      } else {
        return "Erro não mapeado no processo de criação da conta da facilita. Step: `facilita_bank_account_creation_error`"; 
      }
    },
    getAutoScheduledBankAccountError() {
      if (this.errors.error && this.errors.error.hasOwnProperty('bank_account_id')) {
        if (this.errors.error.bank_account_id[0].includes('has already been taken')) {
          let account_number = this.errors.error.bank_account_id[0].split('`')[1]
          return `Conta bancária de número "${account_number}" já cadastrada.`
        }
        if (this.errors.error.bank_account_id[0].includes('cash-in internal account not found for currency')) {
          let currency = this.errors.error.bank_account_id[0].split('`')[1]
          return `Não é possível registrar uma conta exclusiva "${currency}" caso não tenha selecionado esta moeda na lista "Moedas das contas bancárias internas" na aba "Dados gerais"`
        }
        return "Erro no processo de criação da conta da facilita. Step: `set_auto_scheduled_bank_account_error`"
      } else {
        return "Erro não mapeado no processo de criação da conta da facilita. Step: `set_auto_scheduled_bank_account_error`"
      }
    },
    getCompanyTaxesCreationError() {
      if (this.errors.error && this.errors.error.hasOwnProperty('fx_rate')) {
        const invalidRules = this.errors.error.fx_rate.reduce(function(acc, msg){
              if(msg.includes('invalid')) { acc.push(msg.match(/`(.*?)`/)[1]) }
              return acc;
            }, []);

        if (invalidRules.length == 1) {
          return `Taxa Fixa FX (${invalidRules}) não pode ser negativa. Verifique o valor e tente novamente`;
        } else  if (invalidRules.length > 1) {
          return `Taxas Fixas FX (${invalidRules}) não podem ser negativas. Verifique o valor e tente novamente`;
        } else {
          return 'Error ao criar Taxa Fixa FX. Verifique o valor e tente novamente';
        }
      } else {
        return "Erro não mapeado no processo de criação da conta da facilita. Step: `company_taxes_error`";
      }
    },
    closeDialog() {
      this.$emit('closeDialog', this.step)
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/AdminPartnerCreateErrorMessage.vue